import { httpService } from 'shared/api';
import { IAsset } from '../model';

const assetsEndpoint = '/assets';

export const assetApi = {
  uploadFile: async (
    formData: FormData,
    onUploadProgress?: (e: any) => void
  ): Promise<IAsset> => {
    const { data } = await httpService.post(assetsEndpoint + '/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return data;
  }
};
